import { Button } from '@material-ui/core';
import { ClassAttributes, createElement, ReactNode } from 'react';

import Spinner from '../compound/Spinner';

interface Props {
  children: ReactNode;
  isLoading: boolean;
  onClickLoadMore: () => void;
  className?: string;
}

const LoadMoreButton = ({ children, isLoading, onClickLoadMore, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Button
      onClick={onClickLoadMore}
      disabled={isLoading}
      className={className}
      variant="outlined"
      color="primary"
      size="large"
      style={{ textTransform: 'none' }}
      fullWidth
    >
      {isLoading ? <Spinner width={16} height={16} size={16} color="inherit" /> : children}
    </Button>
  );
};

export default LoadMoreButton;
